
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  on: {
    pageBeforeIn: function () {
      this.$app.statusbar.setBackgroundColor('#ffffff');
      this.$app.statusbar.setTextColor('black');
    }
  },
  id: '8687e8f57c',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\n    <div class="page listing-page" data-name="all-categories">\n        <div class="navbar">\n            <div class="navbar-bg"></div>\n            <div class="navbar-inner sliding">\n                <div class="left">\n                    <a href="#" class="link back" aria-label="Back">\n                        <i class="icon icon-back"></i>\n                    </a>\n                </div>\n                <div class="title">All Categories</div>\n            </div>\n        </div>\n        <div class="page-content">\n            <div class="listing-intro">\n                <div class="listing-intro-title">All services</div>\n                <div class="listing-intro-sub">Everything mDOC offers, in one place.</div>\n            </div>\n            <div class="tile-grid">\n                <a href="/subscription/" class="tile-card" aria-label="Doctor Appointment (Subscription)">\n                    <div class="tile-card-icon">\n                        <img src="';
      r += c(ctx_1.assetsUrl, ctx_1);
      r += 'assets/images/category_subscription.svg" alt="" onerror="this.src=\'static/img/default_icon.svg\'">\n                    </div>\n                    <div class="tile-card-name">Doctor Appt (Subscription)</div>\n                </a>\n                <a href="/searchDoctor/1/" class="tile-card" aria-label="Doctor Appointment (Partner)">\n                    <div class="tile-card-icon">\n                        <img src="';
      r += c(ctx_1.assetsUrl, ctx_1);
      r += 'assets/images/category_normal.svg" alt="" onerror="this.src=\'static/img/default_icon.svg\'">\n                    </div>\n                    <div class="tile-card-name">Doctor Appt (Partner)</div>\n                </a>\n                <a href="/searchDoctor/0/" class="tile-card" aria-label="Doctor Appointment (Normal)">\n                    <div class="tile-card-icon">\n                        <img src="';
      r += c(ctx_1.assetsUrl, ctx_1);
      r += 'assets/images/category_normal.svg" alt="" onerror="this.src=\'static/img/default_icon.svg\'">\n                    </div>\n                    <div class="tile-card-name">Doctor Appt (Normal)</div>\n                </a>\n                <a href="/pathlab/" class="tile-card" aria-label="Path Lab">\n                    <div class="tile-card-icon">\n                        <img src="';
      r += c(ctx_1.assetsUrl, ctx_1);
      r += 'assets/images/category_lab.svg" alt="" onerror="this.src=\'static/img/default_icon.svg\'">\n                    </div>\n                    <div class="tile-card-name">Diagnosis (Path Lab)</div>\n                </a>\n                <a href="/blood-bank/" class="tile-card" aria-label="Blood Bank">\n                    <div class="tile-card-icon">\n                        <img src="';
      r += c(ctx_1.assetsUrl, ctx_1);
      r += 'assets/images/category_blood.svg" alt="" onerror="this.src=\'static/img/default_icon.svg\'">\n                    </div>\n                    <div class="tile-card-name">Blood Bank</div>\n                </a>\n                <a href="/ipd/" class="tile-card" aria-label="IPD">\n                    <div class="tile-card-icon">\n                        <img src="';
      r += c(ctx_1.assetsUrl, ctx_1);
      r += 'assets/images/category_ipd.svg" alt="" onerror="this.src=\'static/img/default_icon.svg\'">\n                    </div>\n                    <div class="tile-card-name">IPD</div>\n                </a>\n                ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.data, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                <a href="';
          r += c(ctx_2.link, ctx_2);
          r += '" class="tile-card" aria-label="';
          r += c(ctx_2.name, ctx_2);
          r += '">\n                    <div class="tile-card-icon">\n                        <img src="';
          r += c(root.assetsUrl, ctx_2);
          r += 'assets/images/';
          r += c(ctx_2.image, ctx_2);
          r += '" alt="" onerror="this.src=\'static/img/default_icon.svg\'">\n                    </div>\n                    <div class="tile-card-name">';
          r += c(ctx_2.name, ctx_2);
          r += '</div>\n                </a>\n                ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n            </div>\n        </div>\n    </div>\n';
      return r;
    }(this);
  },
  styleScoped: false
};
    